"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOfferSlots = void 0;
class GetOfferSlots {
    constructor(offerService) {
        this.offerService = offerService;
    }
    execute(request) {
        return this.offerService.getOfferSlots(request);
    }
}
exports.GetOfferSlots = GetOfferSlots;
